export const CORS_PROXY = process.env.REACT_APP_CORS_PROXY;
export const CACHE_DURATION = 300 * 1000; // 5 minutes
export const REFRESH_INTERVAL = 60 * 1000; // 1 minutes